<template>
  <section>
    <buscar-producto @seleccionado="onSeleccionado" />
    <mensaje-inicial :titulo="'No has agregado productos'"
      :subtitulo="'Agrega algunos productos a la lista para venderlos :)'" v-if="productos.length < 1" />
    <div v-if="productos.length > 0">
      <tabla-productos :listaProductos="productos" @quitar="onQuitar" @aumentar="onAumentar"
        @precioCambiado="calcularTotal" />
      <div class="notification is-primary mt-3">
        <p class=" has-text-weight-bold has-text-centered" style="font-size:5em">
          Total ${{ formatoMonto(total) }}
        </p>
        <nav class="level mt-2">
          <div class="level-item has-text-centered" v-if="can('ventas.registrar_venta')">
            <b-button class="button is-responsive" type="is-success" inverted icon-left="check" size="is-large"
              @click="abrirDialogo()">
              Actualizar {{ tipo }}
            </b-button>
          </div>
          <div class="level-item has-text-centered">
            <b-button class="button is-responsive" type="is-danger" inverted icon-left="cancel" size="is-large"
              @click="cancelarVenta">
              Cancelar
            </b-button>
          </div>
        </nav>
      </div>
    </div>
<b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
     <b-modal v-model="abrirModalLocal" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
       aria-label="Modal Seleccionar Local" close-button-aria-label="Close" aria-modal>
       <div class="modal-card" style="width: 320px">
         <section class="modal-card-body">
           <b-field class="mt-3" label="Local emisor">
             <b-select class="wide" placeholder="Seleccionar..." v-model="local" required>
               <option value="jiro">Jirosushi Prime</option>
               <option value="ccs">Oferta Caracas</option>
               <option value="prime">Food Prime</option>
             </b-select>
           </b-field>
         </section>
         <footer class="modal-card-foot" style="justify-content: flex-end">
           <b-button label="Continuar" type="is-primary" @click="confirmarLocal" :disabled="!local" />
         </footer>
       </div>
     </b-modal>
     <b-modal v-model="mostrarDialogo" has-modal-card trap-focus :destroy-on-hide="false" aria-role="dialog"
       aria-label="Modal Terminar Venta" close-button-aria-label="Close" aria-modal>
      <dialogo-agregar-cuenta-apartado :totalVenta="total" @close="onCerrar" @terminar="onTerminar"
        v-if="mostrarAgregarCuenta" :metodos="metodos" :choferes="choferes" :initialCliente="cliente"
        :initialDias="dias" :initialPagado="pagado" :initialDelivery="delivery" @actualizar="actualizar" :id="!!id"
        tipo="cuenta" :initialChoferesSeleccionados="choferesSeleccionados"></dialogo-agregar-cuenta-apartado>
    </b-modal>
     <comprobante-compra :venta="this.ventaRealizada" :tipo="tipoVenta" @impreso="onImpreso" v-if="mostrarComprobante"
       :porPagar="porPagar" :tamaño="tamaño" :enviarCliente="enviarCliente" :local="local" />
  </section>
</template>
<script>
import BuscarProducto from '../Inventario/BuscarProducto.vue'
import TablaProductos from './TablaProductos.vue'
import DialogoAgregarCuentaApartado from './DialogoAgregarCuentaApartado'
import ComprobanteCompra from './ComprobanteCompra'
import MensajeInicial from '../Extras/MensajeInicial'
import AyudanteSesion from '../../Servicios/AyudanteSesion'
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'

export default {
   name: 'EditarCuenta',
   components: {
     BuscarProducto,
     TablaProductos,
     DialogoAgregarCuentaApartado,
     MensajeInicial,
     ComprobanteCompra
   },

   data: () => ({
     cargando: false,
     tamaño: 'tiquera',
     productos: [],
     choferes: [],
     metodos: [],
     total: 0,
     porPagar: 0,
     costoDelivery: null,
     esDelivery: false,
     deliveryGratis: false,
     mostrarDialogo: false,
     mostrarAgregarCuenta: false,
     ventaRealizada: null,
     mostrarComprobante: false,
     enviarCliente: false,
     tipoVenta: "",
     cliente: null,
     metodo: null,
     pagado: 0,
     delivery: null,
     id: null,
     dias: "",
     tipo: null,
     choferesSeleccionados: [],
     rutaRedireccion: null,
      local: null,
      abrirModalLocal: false,
      ventaPendiente: null,
    }),

  computed: {
    idNegocioDeLocal ()
    {
      const mapa = { jiro: 1, ccs: 2, prime: 3 }
      return this.local ? (mapa[this.local] || null) : null
    },
  },

  mounted ()
  {
    this.cargando = true
    const payload = { accion: 'obtener' }

    this.tipo = this.$route.query.tipo

    Promise.all([
      HttpService.obtenerConConsultas('metodos.php', payload),
      HttpService.obtenerConConsultas('choferes.php', payload),
      HttpService.obtenerConConsultas('ventas.php', {
        accion: 'obtener_cuenta_apartado',
        id: this.$route.params.id,
        tipo: this.tipo
      })
    ]).then(([metodos, choferes, cuenta]) =>
    {
      this.metodos = metodos
      this.choferes = choferes
      this.cargando = false
      if (cuenta.idNegocio) {
        const mapaNegocioLocal = { 1: 'jiro', 2: 'ccs', 3: 'prime' }
        this.local = mapaNegocioLocal[cuenta.idNegocio] || null
      }
      this.productos = (cuenta.productos || []).map(this.normalizarProducto)
      this.total = Number(cuenta.total)
      this.cliente = cuenta.cliente
      this.metodo = cuenta.idMetodo || cuenta.simple
      this.pagado = parseFloat(cuenta.pagado)
      this.id = cuenta.id
      this.dias = cuenta.dias

      // El tipo real viene del registro. La ruta puede abrirse sin ?tipo= (marcador o
      // enlace viejo) y entonces la peticion de edicion llegaria sin tipo y no
      // filtraria las lineas de productos_vendidos.
      if (cuenta.tipo) {
        this.tipo = cuenta.tipo
      }

      if (cuenta.delivery) {
        this.costoDelivery = cuenta.delivery.costo || 0
        this.esDelivery = true
        this.deliveryGratis = cuenta.delivery.gratis

        this.delivery = {
          costo: cuenta.delivery.costo,
          destino: cuenta.direccionCliente,
          gratis: cuenta.delivery.gratis,
          idChofer: cuenta.delivery.choferes ? cuenta.delivery.choferes.map(c => c.id) : []
        }

        this.choferesSeleccionados = cuenta.delivery.choferes || []
      } else {
        this.delivery = null
        this.choferesSeleccionados = []
        this.costoDelivery = null
        this.esDelivery = false
        this.deliveryGratis = false
      }
    })
  },

  methods: {
    formatoMonto (valor)
    {
      return Utiles.formatoMonto(valor)
    },

    normalizarProducto (producto)
    {
      const cantidad = Number(producto.cantidad ?? 0)
      return {
        id: Number(producto.id ?? producto.idProducto),
        codigo: producto.codigo,
        nombre: producto.nombre,
        precio: Number(producto.precio ?? producto.precioVenta ?? 0),
        precioVenta: Number(producto.precioVenta ?? producto.precio ?? 0),
        precioVenta2: Number(producto.precioVenta2 ?? 0),
        precioVenta3: Number(producto.precioVenta3 ?? 0),
        precioVenta4: Number(producto.precioVenta4 ?? 0),
        precioVenta5: Number(producto.precioVenta5 ?? 0),
        precioVenta6: Number(producto.precioVenta6 ?? 0),
        precioVenta7: Number(producto.precioVenta7 ?? 0),
        unidad: producto.unidad,
        cantidad,
        cantidadOriginal: cantidad,
        existencia: Number(producto.existencia ?? 0),
        vendidoMayoreo: Boolean(Number(producto.vendidoMayoreo)),
        cantidadMayoreo: Number(producto.cantidadMayoreo ?? 0),
        precioMayoreo: Number(producto.precioMayoreo ?? 0),
        mayoreoAplicado: Boolean(producto.mayoreoAplicado),
      }
    },

    onImpreso (resultado)
    {
      this.mostrarComprobante = resultado

      if (!resultado && this.rutaRedireccion) {
        const ruta = this.rutaRedireccion
        this.rutaRedireccion = null
        this.$router.push(ruta)
      }
    },

    actualizar (prop, valor)
    {
      this[prop] = valor
      this.calcularTotal()
    },

    revalidarStock ()
    {
      let huboCambio = false
      this.productos.forEach(producto =>
      {
        const maxExistencia = this.existenciaEfectiva(producto)
        if (parseInt(producto.cantidad) > parseInt(maxExistencia)) {
          this.$buefy.toast.open({
            type: 'is-warning',
            message: `"${producto.nombre}" se ajustó de ${producto.cantidad} a ${maxExistencia} (stock disponible)`
          })
          producto.cantidad = maxExistencia
          huboCambio = true
        }
      })
      if (huboCambio) this.calcularTotal()
    },

    onTerminar (venta)
    {
      this.calcularTotal()

      // Validar stock de TODOS los productos
      for (const producto of this.productos) {
        const maxExistencia = this.existenciaEfectiva(producto)
        if (parseInt(producto.cantidad) > parseInt(maxExistencia)) {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: `Stock insuficiente para "${producto.nombre}". Tienes ${producto.cantidad} pero el máximo es ${maxExistencia}.`
          })
          this.cargando = false
          return
        }
      }

      // Seleccionar negocio/local antes de guardar (permite cambiar el existente)
      this.ventaPendiente = venta;
      this.mostrarDialogo = false;
      this.mostrarAgregarCuenta = false;
      this.abrirModalLocal = true;
      return;
    },

    async continuarRegistro(venta) {
      let total = this.total

      this.ventaRealizada = {
        total,
        productos: this.productos,
        cliente: venta.cliente.id,
        usuario: AyudanteSesion.usuario().id,
        nombreCliente: (venta.cliente.nombre) ? venta.cliente.nombre : 'MOSTRADOR',
        nombreUsuario: AyudanteSesion.usuario().usuario,
        telefonoCliente: venta.cliente.telefono,
        fecha: new Date().toJSON().slice(0, 10).replace(/-/g, '/')
      }

      let tipo = venta.tipo
      this.ventaRealizada.tipo = tipo
      this.ventaRealizada.pagado = venta.pagado
      this.ventaRealizada.simple = venta.simple
      this.ventaRealizada.origen = venta.origen
      this.ventaRealizada.idMetodo = venta.idMetodo
      this.ventaRealizada.delivery = venta.delivery
      this.ventaRealizada.chofer = venta.chofer
      this.ventaRealizada.pagado = venta.pagado
      this.ventaRealizada.simple = venta.simple
      this.ventaRealizada.origen = venta.origen
      this.ventaRealizada.idMetodo = venta.idMetodo
      this.ventaRealizada.delivery = venta.delivery
      this.ventaRealizada.chofer = venta.chofer
      this.ventaRealizada.dias = venta.dias
      this.ventaRealizada.idNegocio = this.idNegocioDeLocal

      if (tipo !== 'cotiza' && this.ventaRealizada.pagado === '') {
        this.ventaRealizada.pagado = 0
      }

      this.tipoVenta = venta.tipo

      this.cargando = true
      let datos = {
        accion: 'actualizar_cuenta',
        datos: this.ventaRealizada,
        id: this.id,
        tipo: this.tipo
      }

      this.costoDelivery = null
      this.esDelivery = false
      this.deliveryGratis = false

      HttpService.registrar('ventas.php', datos)
        .then(resultado =>
        {
          if (!resultado) return

          // actualizar_cuenta devuelve ahora un objeto (id + mensaje de desempaquetado +
          // vinculaciones invalidas). Antes devolvia un booleano, asi que un error
          // tambien se mostraba como "registrado con exito".
          const id = resultado?.id ?? resultado

          if (resultado?.error) {
            this.cargando = false
            this.$buefy.toast.open({
              type: 'is-danger',
              message: resultado.error
            })
            return
          }

          this.productos = []
          this.total = 0
          this.cargando = false
          this.mostrarTerminarVenta = this.mostrarAgregarCuenta = this.mostrarAgregarApartado = this.mostrarRegistrarCotizacion = false
          this.mostrarDialogo = false
          this.$buefy.toast.open({
            type: 'is-info',
            message: tipo.toUpperCase() + ' registrado con éxito'
          })

          // Si el sistema abrio envases para completar el documento, el operador debe verlo.
          Utiles.mensajesDesempaquetado(resultado).forEach(mensaje =>
            this.$buefy.toast.open(mensaje)
          )

          if (this.tipoVenta === 'cuenta' || this.tipoVenta === 'apartado') {
            return HttpService.obtenerConConsultas('ventas.php', {
              accion: 'por_pagar', id,
            })
          }
        }).then(porPagar =>
        {
          if (porPagar) {
            this.porPagar = porPagar
          }

          this.rutaRedireccion = this.tipo === 'apartado' ? '/reporte-apartados' : '/reporte-cuentas'

           this.$buefy.dialog.confirm({
             message: 'Selecciona el tamaño a imprimir',
             cancelText: 'Carta',
             confirmText: 'Tiquera',
             trapFocus: true,
             onConfirm: () =>
             {
               this.tamaño = 'tiquera'
               this.confirmarEnvioCliente()
             },
             onCancel: () =>
             {
               this.tamaño = 'carta'
               this.confirmarEnvioCliente()
             },
           })
        })
    },

    confirmarEnvioCliente ()
    {
      this.$buefy.dialog.confirm({
        message: '¿Enviar al cliente mediante WhatsApp?',
        cancelText: 'No',
        confirmText: 'Sí',
        trapFocus: true,
        onConfirm: () =>
        {
          this.enviarCliente = true
          this.mostrarComprobante = true
        },
        onCancel: () =>
        {
          this.enviarCliente = false
          this.mostrarComprobante = true
        },
      })
    },

    cancelarVenta ()
    {
      this.$buefy.dialog.confirm({
        title: 'Cancelar venta',
        message: '¿Seguro que deseas cancelar la venta?',
        confirmText: 'Sí, cancelar',
        cancelText: 'No, continuar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
        {
          this.$router.push('/realizar-venta')
        }
      })
    },


     abrirDialogo ()
     {
       this.mostrarDialogo = true
       this.mostrarAgregarCuenta = true
     },

    confirmarLocal ()
    {
      this.abrirModalLocal = false;
      if (this.ventaPendiente) {
        const pendiente = this.ventaPendiente;
        this.ventaPendiente = null;
        this.continuarRegistro(pendiente);
        return;
      }
      this.confirmarEnvioCliente();
    },

    onCerrar (opcion)
    {
      this.mostrarDialogo = false
      if (opcion === 'venta' || opcion === 'cuenta' || opcion === 'apartado' || opcion === 'cotiza')
        this.mostrarTerminarVenta = this.mostrarAgregarCuenta = this.mostrarAgregarApartado = this.mostrarRegistrarCotizacion = false
    },

    onQuitar (id)
    {
      let indice = this.productos.findIndex(producto => producto.id === id)
      if (indice < 0) return
      this.productos.splice(indice, 1)
      this.calcularTotal()
    },

    onAumentar (producto)
    {
      let verificaExistencia = this.verificarExistenciaAlcanzada(producto.existencia, producto.id)

      if (verificaExistencia) return

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(producto.cantidadMayoreo, producto.id, producto.precioMayoreo)
      }

      this.calcularTotal()
      this.revalidarStock()
    },

    onSeleccionado (producto)
    {
      let verificaExistencia = this.verificarExistenciaAlcanzada(producto.existencia, producto.id)

      if (verificaExistencia) return

      if (producto.vendidoMayoreo) {
        this.verificarMayoreo(producto.cantidadMayoreo, producto.id, producto.precioMayoreo)
      }

      let existeEnLista = this.verificarSiEstaEnLista(producto.id)

      if (existeEnLista >= 0) {
        this.aumentarCantidad(existeEnLista)
        this.calcularTotal()
        this.revalidarStock()
        return
      }

      this.agregarALista(producto)
      this.calcularTotal()
      this.revalidarStock()
    },

    agregarALista (producto)
    {
      this.productos.push(
        {
          id: producto.id,
          codigo: producto.codigo,
          nombre: producto.nombre,
          precio: producto.precioVenta,
          precioVenta: producto.precioVenta,
          precioVenta2: producto.precioVenta2,
          precioVenta3: producto.precioVenta3,
          precioVenta4: producto.precioVenta4,
          precioVenta5: producto.precioVenta5,
          precioVenta6: producto.precioVenta6,
          precioVenta7: producto.precioVenta7,
          unidad: producto.unidad,
          cantidad: 1,
          cantidadOriginal: 0,
          existencia: producto.existencia,
          vendidoMayoreo: producto.vendidoMayoreo,
          cantidadMayoreo: producto.cantidadMayoreo,
          precioMayoreo: producto.precioMayoreo,
          mayoreoAplicado: false,
          paquetes: Array.isArray(producto.paquetes) ? producto.paquetes : [],
          paquetes_de: producto.paquetes_de || null,
          conversiones: Array.isArray(producto.conversiones) ? producto.conversiones : [],
          conversionSel: -1,
          factorConversion: 1,
          unidadSel: producto.unidad
        }
      )
    },

    verificarExistenciaAlcanzada (existencia, id)
    {
      let resultado = false
      this.productos.forEach(producto =>
      {
        if (producto.id === id) {
          let maxExistencia = this.existenciaEfectiva(producto)
          if (parseInt(producto.cantidad) > parseInt(maxExistencia)) {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'El producto ' + producto.nombre + ' excede la existencia máxima. Solo tienes ' + maxExistencia
            })
            producto.cantidad = maxExistencia
            resultado = true
          }
        }

      })
      return resultado
    },

    existenciaEfectiva(producto) {
      // Stock disponible = existencia actual + lo ya comprometido en ESTA cuenta
      // + las unidades que aportan los envases con stock.
      // Evita que un producto vendido al 100% (existencia 0) se anule al editar la cuenta.
      // Los envases con vinculación inválida (1 envase rinde menos de 1 unidad) no se
      // cuentan: el backend no puede abrirlos y rechazaría la venta.
      const base =
        (parseFloat(producto.existencia) || 0) +
        (parseFloat(producto.cantidadOriginal) || 0) +
        Utiles.unidadesDesdeEnvases(producto);
      const consumido = Utiles.envasesConsumidosPorDetalle(
        producto,
        this.productos
      );

      return Math.max(0, base - consumido);
    },

    verificarMayoreo (cantidadMayoreo, id, precioMayoreo)
    {
      this.productos.forEach(producto =>
      {
        if (producto.id !== id) return

        if (producto.cantidad >= parseInt(cantidadMayoreo)) {
          if (producto.mayoreoAplicado) return
          this.$buefy.dialog.confirm({
            confirmText: 'Sí, aplicar',
            cancelText: 'No aplicar',
            message: 'El producto ' + producto.nombre + ' tiene mayoreo a partir de ' + cantidadMayoreo + ' piezas, ¿Desea aplicar el mayoreo?',
            onConfirm: () =>
            {
              producto.precio = precioMayoreo
              producto.mayoreoAplicado = true
              this.$buefy.toast.open('Mayoreo aplicado correctamente a ' + producto.nombre)
            }
          })
        } else {
          producto.precio = producto.precioVenta
          producto.mayoreoAplicado = false
        }
      })
    },

    verificarSiEstaEnLista (id)
    {
      return this.productos.findIndex(producto => producto.id === id)
    },

    aumentarCantidad (indice)
    {
      let lista = this.productos
      let producto = lista[indice]
      producto.cantidad++
      this.productos = lista

    },

    calcularTotal ()
    {
      let total = 0
      this.productos.forEach(producto =>
      {
        total = parseFloat(producto.cantidad * producto.precio) + parseFloat(total)
      })

      const costo = parseFloat(this.costoDelivery)

      if (this.esDelivery && !this.deliveryGratis && !isNaN(costo)) {
        total += costo
      }

      this.total = total
    }
  }
}
</script>
